import { render, staticRenderFns } from "./BalancesPlanNameTable.vue?vue&type=template&id=040954d5&"
import script from "./BalancesPlanNameTable.vue?vue&type=script&lang=js&"
export * from "./BalancesPlanNameTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports